// @flow
import type {
  SelectedItemsMap,
} from 'common/folder/types';

const termMenuOption = {
  Edit: 'Edit',
  SuggestionCorrection: 'Suggest correction',
};

type TermMenuOptions = $Values<typeof termMenuOption>;

const actionIconType = {
  badge: 'badge',
  chevron: 'chevron',
  score: 'score',
};

type ActionIconType = $Keys<typeof actionIconType>;

const legalTabType = {
  Legal: 'Legal',
  Privacy: 'Privacy',
};

type LegalTabTypes = $Keys<typeof legalTabType>;

type AddToFolderAction = (selectedItems?: ?
  SelectedItemsMap, id: string, name: string) => void

export type {
  ActionIconType,
  LegalTabTypes,
  TermMenuOptions,
  AddToFolderAction,
};

export {
  actionIconType,
  legalTabType,
  termMenuOption,
};
